import React from 'react';

const ThumbsDownIcon = () => {
    return (
        <svg id="svg" version="1.1" xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
            <path d="M6 1.5H3C2.46957 1.5 1.96086 1.71071 1.58579 2.08579C1.21071 2.46086 1 2.96957 1 3.5V10.5C1 11.0304 1.21071 11.5391 1.58579 11.9142C1.96086 12.2893 2.46957 12.5 3 12.5H6M13 14.5V18.5C13 19.2956 12.6839 20.0587 12.1213 20.6213C11.5587 21.1839 10.7956 21.5 10 21.5L6 12.5V1.5H17.28C17.7623 1.49455 18.2304 1.6636 18.5979 1.97599C18.9654 2.28839 19.2077 2.72309 19.28 3.2L20.66 12.2C20.7035 12.4866 20.6842 12.7793 20.6033 13.0577C20.5225 13.3362 20.3821 13.5937 20.1919 13.8125C20.0016 14.0313 19.7661 14.2061 19.5016 14.3248C19.2371 14.4435 18.9499 14.5033 18.66 14.5H13Z"
                stroke="url(#paint0_linear_3662_10633)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <defs>
                <linearGradient id="paint0_linear_3662_10633" x1="-0.381973" y1="21.5" x2="21.3797" y2="20.7923" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F2547D" />
                    <stop offset="1" stopColor="#FF7959" />
                </linearGradient>
            </defs>
        </svg>
    )
}

export default ThumbsDownIcon;